/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Administration {

    @Serenity.Decorators.registerClass()
    export class IntegrationDialog extends NoboxEntityDialog<IntegrationRow, any> {
        protected getFormKey() { return IntegrationForm.formKey; }
        protected getIdProperty() { return IntegrationRow.idProperty; }
        protected getLocalTextPrefix() { return IntegrationRow.localTextPrefix; }
        protected getNameProperty() { return IntegrationRow.nameProperty; }
        protected getService() { return IntegrationService.baseUrl; }
        protected getDeletePermission() { return IntegrationRow.deletePermission; }
        protected getInsertPermission() { return IntegrationRow.insertPermission; }
        protected getUpdatePermission() { return IntegrationRow.updatePermission; }

        protected form = new IntegrationForm(this.idPrefix);
        protected updateInterface() {
            super.updateInterface();
            if (this.isEditMode()) {
                if (this.get_entity().Provider == "Bit.ly") {
                    this.element.find(".btn-bitly-token").toggle(true);
                }
            }
            this.form.Provider.change(e => {
                var value = this.form.Provider.selectedItem;
                if (value != null) {
                    var endpoint = value["AppEndpoint"];
                    var appname = value["AppName"];
                    this.form.AppEndpoint.value = endpoint;
                    this.form.AppName.value = appname;
                    Serenity.EditorUtils.setRequired(this.form.AppClientId, true);
                    Serenity.EditorUtils.setRequired(this.form.AppSecret, true);
                    this.element.find(".btn-bitly-token").toggle(true);
                } else {
                    this.element.find(".btn-bitly-token").toggle(false);
                    Serenity.EditorUtils.setRequired(this.form.AppClientId, false);
                    Serenity.EditorUtils.setRequired(this.form.AppSecret, false);
                }
            });
        }
        protected getToolbarButtons() {
            var $this = this;
            var buttons = super.getToolbarButtons();
            buttons.push({
                title: this.getButtonTitle("Generate Token"),
                cssClass: "btn-bitly-token",
                icon:"fa fa-check-square text-green",
                separator: true,
                visible:false,
                onClick: () => {
                    if (this.validateForm()) {
                        Q.blockUI({});
                        var baseUrl = new URL('/oauth/access_token', this.form.AppEndpoint.value).href;

                        $.ajax({
                            url: 'https://api-ssl.bitly.com/oauth/access_token',
                            method: 'POST',
                            headers: {
                                'Authorization': 'Basic ' + btoa($this.form.AppClientId.value + ':' + $this.form.AppSecret.value),
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            success: function (result) {
                                Q.notifySuccess("Success get token");
                                $this.form.AppId.value = result;
                                Q.blockUndo();
                            },
                            error: function (response, code, msg) {
                                Q.notifyError(response.responseJSON.message);
                                Q.blockUndo();
                            }
                        });
                    }
                }
            });
            return buttons;
        }
        protected save(callback) {
            var $this = this;
            if (this.validateForm()) {
                if ($this.form.AppId.value != "") {
                    super.save(callback);
                } else {
                    Q.notifyError("Please click Generate Token button first");
                }
            }
        }
    }
}